module.exports = __webpack_public_path__ + "static/img/110.36a385a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200525/110.jpg
// module id = 8M6N
// module chunks = 0